(function () {
  // E.g. prevent Orbeon warning the user about navigating away from the unsaved form because we warn them with a custom dialog
  var stopUnloadEventPropagation = false;
  window.addEventListener('beforeunload', function(event){
    if (stopUnloadEventPropagation) {
      event.stopImmediatePropagation();
    }
  });

  var dialogPolyfill = require("./dialog-polyfill");

  var sessionTimeoutPopup = require("./sessionTimeoutPopup");

  // Locate dialog
  var $dialogs = $("dialog");

  // For holding values needed for 'reusable' dialog
  var $title,
    $message,
    $buttonsContainer,
    $banner,
    $bannerIcon,
    bannerColour,
    bannerIconType,
    bannerIconTypeText;

  $dialogs.each(function () {
    var dialog = this;

    // Register dialog (once per dialog)
    dialogPolyfill.registerDialog(dialog);

    var dialogType = $(dialog).data("dialog-type");

    if (dialogType) {
      var bannerDefaults = {
        bannerColour: "green",
        bannerIconType: "info",
        bannerIconTypeText: "Information",
      };

      var mapIconTypesToText = {
        Information: "fa-info",
        Warning: "fa-exclamation-circle",
      };

      // Check to see if dialog needs some modifications
      if (dialogType.toLowerCase() == "reusable") {
        $title = $(dialog).find(".dialog-title");
        $message = $(dialog).find(".dialog-message");
        $buttonsContainer = $(dialog).find(".dialog-buttons");
        $banner = $title.parent(".notice");
        $bannerIcon = $banner.find("i.icon");

        // If it has the right structure/semantics (i.e. expected elems are present)
        if (
          $title.length &&
          $message.length &&
          $buttonsContainer.length &&
          $banner.length
        ) {
          bannerColour = bannerDefaults.bannerColour; // govuk-blue-banner
          bannerIconType = bannerDefaults.bannerIconType;
          bannerIconTypeText = bannerDefaults.bannerIconTypeText;
        }
      }

      $buttonsContainer.addClass("govuk-button-group");
      $banner.addClass("govuk-" + bannerColour + "-banner");

      $bannerIcon
        .removeClass("fa-icontype")
        .addClass(mapIconTypesToText[bannerIconTypeText])
        .find("span.visually-hidden")
        .text(bannerIconTypeText);
    }
  });

  // Variable for tracking the Dialog Popup requester
  var $interruptedElement = null;
  var dialogSelector = null;
  var ledgerUuid;

  // var dialogId = $(dialog).attr('id');

  // Tracking whether a datagrid delete operation is to be done
  var datagridDeleteOperationObject = null;
  var toDeleteFromDatagrid = false;

  var primaryHref;
  var baseHref;
  var reportHref;

  var receiptValidation;
  var paymentValidation;

  function isInLedgerPage() {
    return $("#ledgerTable").length > 0;
  }
  function isInDataStorePage() {
    return $("#datastore-page").length > 0;
  }

  function isInTestDataStorePage() {
    return $("#test-datastore-page").length > 0;
  }

  if (isInLedgerPage()) {

    $(".remove-btn").click(".dialog-open[data-dialog-target]", function (e) {
      e.preventDefault();
      ledgerUuid = $(this).attr("id");

      $interruptedElement = $(e.target);
      dialogSelector = $interruptedElement
        .closest("[data-dialog-target]")
        .data("dialog-target");


      // Initialise the dialog 'title' and 'message' with the text of the clicked link
      var dialogType = $(dialogSelector).data("dialog-type");

      if (
        dialogType &&
        dialogType.toLowerCase() == "reusable" &&
        $interruptedElement
      ) {
        $title.text($interruptedElement.text());
        $message.find("span").text($interruptedElement.text().toLowerCase());
      }

      console.log(
        "interruptedElement",
        $interruptedElement
          .closest("[data-dialog-target]")
          .data("dialog-target"),
      );

      if (dialogSelector) {
        $("body").addClass("dialog-is-open");
        $(dialogSelector)[0].showModal();
      }
    });
  }
  // Register clicks
  $("body").on("click", ".dialog-open[data-dialog-target]", function (e) {
    e.preventDefault();

    $interruptedElement = $(e.target);

    dialogSelector = $interruptedElement
      .closest("[data-dialog-target]")
      .data("dialog-target");


    if (dialogSelector == "#start-transaction-review") {
      var href = $interruptedElement.attr("href").split("&");
      var paymentDate = href[1].split("=")[1];
      var receiptDate = href[2].split("=")[1];
      paymentValidation = href[3].split("=")[1];
      $("#paymentValid").text(paymentValidation);
      $("#paymentValidationDate").val(paymentValidation);
      receiptValidation = href[4].split("=")[1];
      $("#receiptValid").text(receiptValidation);
      $("#receiptValidationDate").val(receiptValidation);

      if (
        paymentDate == undefined ||
        paymentDate == null ||
        paymentDate == ""
      ) {
        $("#paymentGroup").attr("hidden", "hidden");
        $("#paymentValid").closest(".form-group").attr("hidden", "hidden");
      }
      if (
        receiptDate == undefined ||
        receiptDate == null ||
        receiptDate == ""
      ) {
        $("#receiptGroup").attr("hidden", "hidden");
        $("#receiptValid").closest(".form-group").attr("hidden", "hidden");
      }
      primaryHref = $interruptedElement.attr("href");
      baseHref = href[0];
      $("#paymentDate").val(paymentDate);
      $("#receiptDate").val(receiptDate);
      $interruptedElement.attr("href", baseHref);
      $(dialogSelector)
        .find("#dialog-title")
        .text("Start Transactions Review Process");
    }

    if (dialogSelector == "#download-detailed-report") {
      reportHref = $interruptedElement.attr("href");
      $(dialogSelector)
        .find("#dialog-title")
        .text("Download detailed audit report");
    }

    // Initialise the dialog 'title' and 'message' with the text of the clicked link
    var dialogType = $(dialogSelector).data("dialog-type");

    if (
      dialogType &&
      dialogType.toLowerCase() == "reusable" &&
      $interruptedElement
    ) {
      $title.text($interruptedElement.text());
      $message.find("span").text($interruptedElement.text().toLowerCase());
    }

    if (dialogSelector == "#reject-transaction") {
      $(dialogSelector)
        .find("#dialog-title")
        .text("Please confirm to continue");
    }

    if (dialogSelector == "#confirm-delete-dataset") {
      $(dialogSelector).find("#dialog-title").text("Warning!");
    }

    console.log(
      "interruptedElement",
      $interruptedElement.closest("[data-dialog-target]").data("dialog-target"),
    );

    if (dialogSelector) {
      $("body").addClass("dialog-is-open");
      $(dialogSelector)[0].showModal();
    }
  });
  if (isInDataStorePage() || isInTestDataStorePage) {
    $("#enableBtnNotify").click(
      ".dialog-open[data-dialog-target]",
      function (e) {
        e.preventDefault();

        $interruptedElement = $(e.target);

        dialogSelector = $interruptedElement
          .closest("[data-dialog-target]")
          .data("dialog-target");


        // Initialise the dialog 'title' and 'message' with the text of the clicked link
        var dialogType = $(dialogSelector).data("dialog-type");

        if (
          dialogType &&
          dialogType.toLowerCase() == "reusable" &&
          $interruptedElement
        ) {
          $title.text($interruptedElement.text());
          $message.find("span").text($interruptedElement.text().toLowerCase());
        }

        console.log(
          "interruptedElement",
          $interruptedElement
            .closest("[data-dialog-target]")
            .data("dialog-target"),
        );

        if (dialogSelector) {
          $("body").addClass("dialog-is-open");
          $(dialogSelector)[0].showModal();
        }
      },
    );
  }

  $("body").on(
    "dialog.type.delete",
    ".js-dropdown-list-item.dialog-open",
    function (event, data) {
      toDeleteFromDatagrid = true;

      // Initialise object to be used in the delete operation
      datagridDeleteOperationObject = {
        datagrid: data.table,
        row: data.row,
      };
    },
  );

  //
  // Check Dialog Button for:
  // - its identity; using 'target' method
  // - which action to execute
  // - etc.
  // ...but always close dialog after anything
  //
  $(".dialog-button").click(function (e) {
    e.preventDefault();
    var $clickedButton = $(e.target);
    var grantId = $("#grantId").val();


    // If the 'proceed/continue' button was clicked....
    if ($clickedButton.hasClass("dialog-proceed")) {
      if (isInLedgerPage()) {
        $.ajax({
          type: "GET",
          dataType: "JSON",
          url:
            "/setup/grants/delete-ledger-code?id=" +
            grantId +
            "&ledger-code-id=" +
            ledgerUuid,
        })
          .done(function (response) {
            redirectTo(response[0].key);
          })
          .fail(function (response) {
          });
      }
      if ($interruptedElement.is("a")) {
        stopUnloadEventPropagation = true;
        if ($interruptedElement.attr("href") != "javascript:void(0)") {
          sessionTimeoutPopup.sessionTimeout && sessionTimeoutPopup.sessionTimeout(); //To reset the session timer
        }
        if (toDeleteFromDatagrid) {
          datagridDeleteOperationObject.datagrid.jsGrid(
            "deleteItem",
            datagridDeleteOperationObject.row,
          );
        } else {
          // @todo Error-checking for when target 'href' attribute is missing
          window.location.assign($interruptedElement.attr("href"));
          if (dialogSelector == "#download-detailed-report") {
            $("#download-audit-report").attr(
              "href",
              "/admin/users/download-report",
            );
            $("#download-detailed-report :input").val("");
          }
        }
      } else if (
        $interruptedElement.is("input[type=submit]") ||
        $interruptedElement.is("input[type=button]") ||
        $interruptedElement.is("button[type=submit]")
      ) {
        // perform some action... e.g. submit form
        var $form = $interruptedElement.closest("form");
        if ($form) {
          $form[0].action =
            $interruptedElement.attr("formaction") || $form[0].action;
          $form.submit();
        } else {
          throw new Error(
            'Form element is needed if the clicked element is "input[type=submit]", "input[type=button]", or "button[type=submit]"',
          );
        }
      }
    }
    if ($clickedButton.hasClass("stop-review")) {
      $interruptedElement.attr("href", primaryHref);
    }
    $(dialogSelector).trigger("dialog.close");
  });

  function redirectTo(u) {
    window.location.href = u;
  }

  $("body").on("dialog.close", $(dialogSelector), function (e) {
    e.preventDefault();

    if (dialogSelector) {
      var id = $(dialogSelector)[0].id;
      var dialog = document.getElementById(id);
      dialog.close();
      //            $(dialogSelector).removeAttr('open');
      //            $(dialogSelector).close();
      $("body").removeClass("dialog-is-open");
      if (dialogSelector == "#download-detailed-report") {
        $("#download-audit-report").attr(
          "href",
          "/admin/users/download-report",
        );
        $("#download-detailed-report :input").val("");
      }
    }
  });

  $("#paymentDate").on("change", function () {
    var receiptDateVal = $("#receiptDate").val();
    var paymentDateVal = $(this).val();
    var url =
      baseHref +
      "&paymentReviewDate=" +
      paymentDateVal +
      "&receiptReviewDate=" +
      receiptDateVal;
    $interruptedElement.attr("href", url);
  });

  $("#receiptDate").on("change", function () {
    var receiptDateVal = $(this).val();
    var paymentDateVal = $("#paymentDate").val();
    var url =
      baseHref +
      "&paymentReviewDate=" +
      paymentDateVal +
      "&receiptReviewDate=" +
      receiptDateVal;
    $interruptedElement.attr("href", url);
  });

  $("#endAuditDate").on("change", function () {
    var startDateVal = $("#startAuditDate").val();
    var endDateVal = $(this).val();
    var url =
      reportHref + "?from-date=" + startDateVal + "&to-date=" + endDateVal;
    $interruptedElement.attr("href", url);
  });
  $("#startAuditDate").on("change", function () {
    var startDateVal = $(this).val();
    var endDateVal = $("#fromAuditDate").val();
    var url =
      reportHref + "?from-date=" + startDateVal + "&to-date=" + endDateVal;
    $interruptedElement.attr("href", url);
  });
})();
